import React from 'react'

export function VodIcon(stroke?: string) {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.49832 9.58801L17.0783 5.64036L16.4466 3.58757C16.2098 2.79804 15.3413 2.32432 14.4728 2.56118L3.81414 5.71931C3.0246 5.95617 2.55089 6.82465 2.78775 7.69314L3.49832 9.58801ZM3.49832 9.58801H17.7099V15.9043C17.7099 16.3231 17.5435 16.7247 17.2474 17.0208C16.9513 17.317 16.5496 17.4833 16.1308 17.4833H5.07739C4.65859 17.4833 4.25695 17.317 3.96082 17.0208C3.66469 16.7247 3.49832 16.3231 3.49832 15.9043V9.58801ZM6.02483 5.08768L8.47237 8.16686M10.9199 3.58757L13.3675 6.7457"
                stroke={stroke || 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
